// @flow

import { connect } from "react-redux";
import BlogCard from "./view";
import Photo from "./photo";

export default connect(
    () => ({
        Photo
    }),
    () => {}
)(BlogCard);



// WEBPACK FOOTER //
// ./src/blog-card/photos/index.js